import { render, staticRenderFns } from "./RestoreLocations.vue?vue&type=template&id=4c8b780c&"
import script from "./RestoreLocations.vue?vue&type=script&lang=js&"
export * from "./RestoreLocations.vue?vue&type=script&lang=js&"
import style0 from "./RestoreLocations.vue?vue&type=style&index=0&id=4c8b780c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports